<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  validations: {
    invalidCheck: {},

    form: [],
  },
  methods: {
    // validate
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit("on-validate", this.$data, isValid);
      return isValid;
    },
  },
};
</script>

<template>
  <!-- start page title -->
  <div>
    <div class="row">
      <hr class="hr-title" />
      <div class="break-title"><h5 class="mb-4">ملاحظات</h5></div>

      <div class="col-md-12">
        <ul class="notes">
          <li>
            <p>
              يتم كتابة اسم احتياط للمنظمة او الفريق التطوعي ليتم اختياره كإسم رئيسي في
              حال تم حجز الإسم مسبقاً من قبل منظمة او فريق آخر.
            </p>
          </li>
          <li>
            <p>
              فترة نفاذ الاسم 30 يوما من ارسال اشعارالمركز بالموافقة وفي حال تجاوز الوقت
              ولم يرسل طلب التأسيس والتسجيل يعتبر الاسم لاغياً (يستثنى من ذلك في حال عدم
              استخدام هذا الاسم من منظمة اخرى).
            </p>
          </li>
          <li>
            <p>
              يجب ان يكتب الاسم بالانكليزي و العربي واي استمارة لا يكتب فيها الاسم باللغة
              الانكليزية مع العربية سيهمل.
            </p>
          </li>
          <li>
            <p>رقم الهاتف : 07772225487</p>
          </li>
          <li>
            <p>البريد الالكتروني الرسمي : volunteer.work.center@gmail.com</p>
          </li>
          <li>
            <p>حساب تلكرام : @V_work_BOT</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <!-- end page title -->
</template>
